module.exports = __webpack_public_path__ + "static/media/5-fullt.fb0c6ddc.mp3";